import { useState } from "react";
import { createPortal } from "react-dom";

// Tiny preview that follows the mouse (to the right of the pointer). Used on
// the edit pencil: deliveries show the products to buy, trips show the
// observations — without opening the dialog or blocking the list.
export default function NotesHoverTip({ trip, children, testId }) {
  const [pos, setPos] = useState(null);
  const isDelivery = trip?.trip_type === "delivery";
  const items = (trip?.items || "").trim();
  const notes = (trip?.notes || "").trim();
  const sections = isDelivery
    ? [{ label: "Productos", text: items, empty: "Sin productos" }, ...(notes ? [{ label: "Observaciones", text: notes }] : [])]
    : [{ label: "Observaciones", text: notes, empty: "Sin observaciones" }];
  const hasContent = Boolean(items || notes);
  const move = (e) => setPos({ x: e.clientX + 14, y: e.clientY + 8 });
  const tipW = 240;
  const left = pos ? Math.min(pos.x, window.innerWidth - tipW - 8) : 0;
  const top = pos ? Math.min(pos.y, window.innerHeight - 80) : 0;
  return (
    <span className="relative inline-flex" onMouseEnter={move} onMouseMove={move} onMouseLeave={() => setPos(null)}>
      {children}
      {hasContent && (
        <span
          data-testid={`${testId || "notes-hover-tip"}-dot`}
          title={isDelivery ? "Tiene productos / observaciones" : "Tiene observaciones"}
          className={`pointer-events-none absolute -top-1 -right-1 h-2 w-2 rounded-full ring-2 ring-zinc-950 animate-pulse ${isDelivery ? "bg-emerald-400" : "bg-amber-400"}`}
        />
      )}
      {pos && createPortal(
        <div
          data-testid={testId || "notes-hover-tip"}
          style={{ position: "fixed", left, top, width: "max-content", maxWidth: tipW, zIndex: 9999, pointerEvents: "none" }}
          className={`rounded border bg-zinc-950/95 backdrop-blur px-2 py-1 shadow-xl space-y-1 ${isDelivery ? "border-emerald-500/40" : "border-amber-500/40"}`}
        >
          {sections.map((s) => (
            <div key={s.label}>
              <div className={`text-[8px] font-mono uppercase tracking-widest mb-0.5 ${s.label === "Productos" ? "text-emerald-400/90" : "text-amber-400/90"}`}>{s.label}</div>
              <div className={`text-[10px] leading-snug whitespace-pre-wrap break-words uppercase ${s.text ? "text-zinc-100" : "text-zinc-500 italic"}`}>
                {s.text || s.empty}
              </div>
            </div>
          ))}
        </div>,
        document.body
      )}
    </span>
  );
}
